import React from "react";
import Select, { Styles } from "react-select";
import { ReactSelectDropdownOption } from "@pepdirect/ui/dropdown/types";
import { DropdownIndicator } from "@pepdirect/ui/DropdownIndicator";

const selectStyles: Partial<Styles<ReactSelectDropdownOption, false>> = {
  container: (provided) => ({
    ...provided,
    fontWeight: 700,
  }),
  valueContainer: (provided) => ({
    ...provided,
    flexWrap: "initial",
    padding: 0,
  }),
  control: (provided) => ({
    ...provided,
    padding: 0,
    boxShadow: "none",
    alignItems: "center",
    border: "1px solid #2C2925 !important",
    borderRadius: 35,
    height: "46px",
    cursor: "pointer",
    fontSize: "16px",
    width: "100%",
    appearance: "none",
    backgroundColor: "#E8E0C4",
    color: "#2C2925",
    backgroundImage: "none",
    overflow: "hidden",
    maxWidth: "100%",
    textAlign: "left",
    WebkitAppearance: "none",
    MozAppearance: "none",
    zIndex: 5,
  }),
  singleValue: () => ({
    padding: "8px 0 8px 18px",
    whiteSpace: "nowrap",
    alignSelf: "center",
  }),
  indicatorSeparator: () => ({
    visibility: "hidden",
  }),
  indicatorsContainer: () => ({
    width: "16px",
    height: "9px",
    marginRight: "12px",
    backgroundColor: "#2C2925",
    WebkitClipPath: "polygon(100% 0%, 0 0%, 50% 100%)",
    clipPath: "polygon(100% 0%, 0 0%, 50% 100%)",
    pointerEvents: "none",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#E8E0C4",
    border: "1px solid #2C2925",
    borderRadius: "10px",
    padding: "5px 0 !important",
    overflowY: "auto",
    width: "100%",
    maxWidth: "100%",
    zIndex: 6,
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: "#E8E0C4",
    maxHeight: "100%",
  }),
  option: (_, { isSelected, isFocused }) => ({
    textAlign: "left",
    backgroundColor: "transparent",
    fontSize: "14px",
    padding: "8px 0 !important",
    margin: "0 15px !important",
    listStyleType: "none",
    borderBottom: "1px solid #2C2925",
    color: "#2C2925",
    fontWeight: isFocused ? 700 : 400,
    wordBreak: "keep-all",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    cursor: "pointer",
    "&:last-child": {
      borderBottom: "none",
    },
  }),
};

export function SelectDropdown({
  options,
  selectedOption,
  onChange,
}: {
  options: ReactSelectDropdownOption[];
  selectedOption: ReactSelectDropdownOption;
  onChange: (val: string) => Promise<void>;
}): JSX.Element {
  return (
    <>
      <div>
        <Select
          instanceId={selectedOption.label}
          value={selectedOption}
          onChange={(val) => onChange((val as ReactSelectDropdownOption).value)}
          options={options}
          styles={selectStyles}
          components={{ DropdownIndicator }}
          isSearchable={false}
        />
      </div>
    </>
  );
}
